import { render, staticRenderFns } from "./Lockscreen.vue?vue&type=template&id=0771884d&"
import script from "./Lockscreen.vue?vue&type=script&lang=js&"
export * from "./Lockscreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports